<div class="company-container">
  <button mat-icon-button (click)="routing.goBack()"><mat-icon>arrow_back_ios</mat-icon></button>
  <a [routerLink]="nav_path.home" aria-label="HOME" rel="noreferrer">
    <img class="company-logo" alt="home button" src="assets/imgs/logo.webp" [height]="50" />
  </a>

  <div class="company-logo-text-container">
    Editing in
    <a class="company-logo-text" [routerLink]="nav_path.home" aria-label="HOME" rel="noreferrer">
      &nbsp;Anonymous Systems
    </a>
  </div>
</div>

<div class="icon-actions">
  <button mat-raised-button class="save-post-button" color="primary"
          (click)="previewStory(true)" [disabled]="!story.title || !rst.transform(story.content)">Preview</button>

  <anon-user-header></anon-user-header>
</div>
